import { render, staticRenderFns } from "./NominationModal.vue?vue&type=template&id=3e4b25b6&scoped=true&"
import script from "./NominationModal.vue?vue&type=script&lang=js&"
export * from "./NominationModal.vue?vue&type=script&lang=js&"
import style0 from "./NominationModal.vue?vue&type=style&index=0&id=3e4b25b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4b25b6",
  null
  
)

export default component.exports